import React from "react";
import "../../../assets/css/custom.css";

const DynamicText = ({
  capteurId,
  dataText,
  config,
  unite,
  isOld = false,
  date,
  showEpochDate = false,
}) => {
  // Fonction pour formater la date à partir d'une valeur epoch
  const formatEpochDate = (epochTimestamp) => {
    if (!epochTimestamp) return "";
    const date = new Date(epochTimestamp * 1000); // Convertir l'epoch (secondes) en millisecondes
    return date.toLocaleString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  if (isOld) {
    return (
      <>
        <p>
          {" "}
          {config} : <span className="text-realtime-value">{dataText}</span>{" "}
          {unite}
          {`   ${date}`}
   </p>
      </>
    );
  } else {
    const sensor = config.find((sensor) => sensor.id === capteurId);

    if (sensor) {
      return (
        <>
          <p>
            {" "}
            {sensor.label} :{" "}
            <span className="text-realtime-value">
              {dataText[`capteur_${capteurId}_data`]}
            </span>{" "}
            {sensor.unite}
            {showEpochDate && dataText.epoch_date && (
              <span className="text-date-value">
                {" "}Date: {formatEpochDate(dataText.epoch_date)}
              </span>
            )}
          </p>
        </>
      );
    }
    return null;
  }
};

export default DynamicText;
